<div class="mt-6 w-full flex flex-col gap-5">
  <!-- Filter Bar -->
  <p-card>
    <div class="flex flex-wrap items-center gap-4">
      <p-datepicker
        [(ngModel)]="rangeDates"
        selectionMode="range"
        [readonlyInput]="true"
        [showIcon]="true"
        dateFormat="dd.mm.yy"
        (onSelect)="onDateSelect()"
      />
    </div>
  </p-card>

  <!-- KPI Boxes -->
  <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
    <app-ticker-card
      [titleText]="'dashboard.avgRoutesPerVisit' | translate"
      [total]="avgRoutesPerVisit().toFixed(1)"
      icon="route"
      tone="info"
    />
    <app-ticker-card
      [titleText]="'dashboard.totalVisits' | translate"
      [total]="totalVisits().toString()"
      icon="users"
      tone="info"
    />
  </div>

  <!-- Beliebteste Route: Horizontal Bar Chart -->
  <p-card>
    <ng-template #title>
      <h2>{{ 'dashboard.popularRoutes' | translate }}</h2>
    </ng-template>
    <app-simple-bar-chart-card [data]="popularRoutesData()" [orientation]="'horizontal'" />
  </p-card>

  <!-- Durchschnittliche Zeit pro Route: Table -->
  <p-card>
    <ng-template #title>
      <h2>{{ 'dashboard.avgTimePerRoute' | translate }}</h2>
    </ng-template>
    <p-table
      [value]="avgTimePerRoute()"
      stripedRows
      showGridlines
      [scrollable]="true"
      sortField="avg_minutes"
      [sortOrder]="-1"
    >
      <ng-template #header>
        <tr>
          <th pSortableColumn="route_name">
            {{ 'dashboard.routeName' | translate }}
            <p-sortIcon field="route_name" />
          </th>
          <th pSortableColumn="avg_minutes">
            {{ 'dashboard.avgMinutes' | translate }}
            <p-sortIcon field="avg_minutes" />
          </th>
          <th pSortableColumn="total_runs">
            {{ 'dashboard.totalRuns' | translate }}
            <p-sortIcon field="total_runs" />
          </th>
        </tr>
      </ng-template>
      <ng-template #body let-row>
        <tr>
          <td>{{ row.route_name }}</td>
          <td>{{ row.avg_minutes }} min</td>
          <td>{{ row.total_runs }}</td>
        </tr>
      </ng-template>
      <ng-template #emptymessage>
        <tr>
          <td colspan="3" class="text-center text-gray-400">
            {{ 'dashboard.noData' | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>

  <!-- Durchläufe pro Route pro Tag/Stunde -->
  <p-card>
    <ng-template #title>
      <div class="flex flex-wrap items-center justify-between gap-4">
        <h2>{{ 'dashboard.runsTimeline' | translate }}</h2>
        <p-selectbutton
          [options]="groupByOptions"
          [ngModel]="runsGroupBy()"
          (ngModelChange)="runsGroupBy.set($event); onRunsGroupByChange()"
          optionLabel="label"
          optionValue="value"
        />
      </div>
    </ng-template>
    <app-line-chart-card
      [data]="runsTimelineData()"
      [series]="runsTimelineSeries()"
      [zoomable]="runsTimelineData().length > 0"
      xAxisType="time"
    />
  </p-card>

  <!-- Durchläufe Total pro Stunde -->
  <p-card>
    <ng-template #title>
      <h2>{{ 'dashboard.runsPerHour' | translate }}</h2>
    </ng-template>
    <app-mixed-chart-card
      [data]="runsPerHourData()"
      [barAxis]="{ name: 'Gesamt' }"
      [lineAxis]="{ name: 'Ø pro Tag' }"
    />
  </p-card>

  <!-- Besucher pro Tag/Stunde -->
  <p-card>
    <ng-template #title>
      <div class="flex flex-wrap items-center justify-between gap-4">
        <h2>{{ 'dashboard.visitorsTimeline' | translate }}</h2>
        <p-selectbutton
          [options]="groupByOptions"
          [ngModel]="visitorsGroupBy()"
          (ngModelChange)="visitorsGroupBy.set($event); onVisitorsGroupByChange()"
          optionLabel="label"
          optionValue="value"
        />
      </div>
    </ng-template>
    <app-line-chart-card
      [data]="visitorsTimelineData()"
      [series]="visitorsTimelineSeries"
      [zoomable]="visitorsTimelineData().length > 24"
      xAxisType="time"
    />
  </p-card>
</div>
